<template>
  <div class="auth-wrapper auth-v2" :dir="$functions.currentLangDirection()">
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <h2 class="brand-text text-primary ml-1" />
        <span class="brand-logo">
          <!-- <b-img
              :src="appLogoImage"
            alt="logo"
          />-->
        </span>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="12"
        class="d-none d-md-flex d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-3 form-auth "
          :style="{ backgroundImage: `url(${backgroundUrl})` }"
          v-bind:class="{ mainbox: !isMobile}"
          style="background-size: cover;background-position: center;direction: rtl;" >
        <b-col
          sm="12"
          md="12"
          lg="12"
          style="margin-top: -140px;"
          :dir="$functions.currentLangDirection()"
          class="box2 px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('Send verification code') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Enter the code sent') }}.
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginVerifyForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-register-form mt-2"
              @submit="loginVerifyForm"
            >

              <!-- security code -->
              <b-form-group
                id="div-securitycode"
                label-for="register-mobile"
                label=""
                style="direction: ltr"
              >
                <b-form-input
                  v-model="code"
                  class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                  maxlength="5"
                  style="letter-spacing: .9rem;font-size: 2.1rem"
                  size="lg"
                  name="code"
                  rules="required"
                  autocomplete="off"
                  @keydown="bl00=$event.target.value"
                  @keyup="queryForKeywords"
                  v-on:keyup="codeChangeEn($event)"
                />
              </b-form-group><p class="text-center mt-2">
              {{ $t('Resend the code until') }}
                {{ timerCount }}
              {{ $t('Second') }}
              </p><b-button
                variant="light"
                block
                type="submit"
                :disabled="invalid && loading"
              ><b-spinner
                v-if="loading"
                variant="outline-primary"
                small
              />
              {{ $t('Send') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>{{ $t('No code sent') }}</span>
            <b-link :to="{name:'login'}">
              <span style="font-weight: bolder; text-decoration: underline">&nbsp;{{ $t('Change mobile number') }}</span>
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BButton, BForm, BFormGroup, BFormInput, BImg, BCardTitle, BCardText, BSpinner,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router'
import { functions } from '@/functions'

Vue.prototype.$functions = functions

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BSpinner,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      code: '',
      status: '',
      password: '',
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      // validation
      required,
      codeVerify: '',
      bl00: '1',
      timerEnabled: true,
      timerCount: 120,
      sending: false,
      isMobile: Vue.prototype.$functions.isMobile(),
      loading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            // eslint-disable-next-line no-plusplus
            this.timerCount--
            if (this.timerCount === 0) {
              this.$router.push('/login')
            }
          }, 1000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  beforeCreate() {
    if (typeof this.$mobile === 'undefined') {
      this.$router.push('/login')
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
    document.getElementById('div-securitycode').getElementsByTagName('input')[0].focus()
  },
  methods: {
    changeAppLanguage(lang) {
      localStorage.setItem('locale', lang)
      window.location = '/'
    },
    loginVerifyForm(event) {
      if (event) event.preventDefault()
      if (this.sending) return
      this.$refs.loginVerifyForm.validate().then(success => {
        this.sending = true
        if (success) {
          this.loading = true
          this.$store.dispatch('auth/loginVerify', {
            code: this.code,
            mobile: this.$mobile,
          }).then(
            (res) => {
              // console.log(res)
              this.loading = false
              if(res.result.numDevice === 0) {
                this.$router.push('/newdevice')
              }else {
                this.$router.push('/')
              }

              //   this.sending = false
            }, error => {
              this.sending = false
              this.loading = false
              this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            },
          )
        }
      })
    },
    queryForKeywords(e) {
      this.$nextTick(() => {
        const charCode = (e.which) ? e.which : e.keyCode
        if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
          if (this.code.length === 5) {
            this.loginVerifyForm(null)
          }
        }
      })
    },
    codeChangeEn(event) {
      this.code = this.$functions.fixNumbers(event.target.value)
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{
  width: 70px;
}
.auth-wrapper .auth-bg{
  background-color: #232633;
  color: #fff;
}
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{
  color: #fff !important;
}

.mainbox{
  background: #344935d6   !important;
  position: absolute;top: 10%;margin-left: auto;margin-right: auto;left: 0;right: 0;width: 400px;height: 500px;border-radius: 2%;
}
.mainbox .box2{
  margin-top: -40px !important;
}
</style>
